import en from './en'

// Localized overrides + Prediction Market translations (ported from B2B)
const reservedTranslationsWithUniqueKeyNames = {
  leadingSpaceNotAllowed: 'No se permite espacio al inicio.',
  trailingSpaceNotAllowed: 'No se permite espacio al final.',
  mustbeAtleastCharacters: '{{label}} debe tener al menos {{minNumber}} caracteres',
  cannotExceedCharacters: '{{label}} no puede superar {{maxNumber}} caracteres',
  numberMustbeAtleast: '{{label}} debe ser al menos {{minNumber}}',
  numberCannotExceed: '{{label}} no puede superar {{maxNumber}}',
  isRequired: '{{label}} es obligatorio',
  emptySpaceNotContain: 'Este campo no puede contener espacios',
  404: '404',
  register: 'Registrarse',
  login: 'Iniciar sesión',
  comingSoon: 'Próximamente',
  submit: 'Enviar',
  email: 'Correo electrónico',
  termsConditions: 'Términos y condiciones',
  password: 'Contraseña',
  eighteenPlus: 'Soy mayor de 18 años y acepto los Términos del servicio',
  signUp: 'Registrarse',
  createNewAccount: 'Crear nueva cuenta',
  fullName: 'Nombre completo',
  referralCode: 'Código de referido',
  confirmPassword: 'Confirmar contraseña',
  facebook: 'Facebook',
  google: 'Google',
  haveAnAccount: '¿Ya tienes una cuenta? ',
  pageNotFound: 'No podemos encontrar la página que estás buscando.',
  error: 'Error',
  somethingWentWrong: 'Algo salió mal.',
  personalDetails: 'Datos personales',
  firstName: 'Nombre',
  lastName: 'Apellido',
  dateOfBirth: 'Fecha de nacimiento',
  phoneNumber: 'Número de teléfono',
  change: 'Cambiar',
  saveChanges: 'Guardar cambios',
  currentPassword: 'Contraseña actual',
  newPassword: 'Nueva contraseña',
  myProfile: 'Mi perfil',
  transactions: 'Transacciones',
  deposit: 'Depositar',
  withdraw: 'Retirar',
  referral: 'Referido',
  changePassword: 'Cambiar contraseña',
  logout: 'Cerrar sesión',
  currency: 'Moneda.',
  view: 'Ver',
  ok: 'Aceptar',
  cancel: 'Cancelar',
  userName: 'Nombre de usuario',
  passwordRegexMatch: 'La contraseña debe contener una mayúscula, un número y un carácter especial',
  invalidEmailFormat: 'Formato de correo electrónico inválido',
  noRecordsFound: 'No se encontraron registros'

}

const apiSuccessMessagesTranslations = {
  loginSuccessfully: 'Inicio de sesión exitoso.',
  logoutSuccessfully: 'Cierre de sesión exitoso.',
  passwordUpdateSuccessfully: 'Contraseña actualizada correctamente.',
  updatePlayerStatusSuccessfully: 'Estado del jugador actualizado correctamente.',
  resetPasswordSuccessfully: 'Contraseña restablecida correctamente.',
  signupSuccessfully: 'Registro exitoso.',
  betPlacedSuccessfully: 'Apuesta realizada correctamente.',
  betCancelledSuccessfully: 'Apuesta cancelada correctamente.'

}

const apiErrorMessagesTranslations = {
  UnAuthorized: 'Tu sesión ha caducado',
  LoginFailedError: 'Error de inicio de sesión',
  InvalidCredentialsError: 'Credenciales inválidas',
  InvalidTokenError: 'El token no es válido',
  InvalidSessionError: 'La sesión ha expirado',
  CreateUserError: 'No se pudo crear el usuario',
  DataMismatchError: 'Los datos no coinciden',
  UserNotFoundError: 'Usuario no encontrado',
  DuplicateEmailError: 'El correo electrónico ya existe',
  RequestInputValidationError: 'Por favor revisa los datos de la solicitud',
  ResponseInputValidationError: 'La validación de la respuesta falló; consulta el esquema JSON',
  InternalServerError: 'Error interno del servidor',
  InvalidCredentials: 'Las credenciales no coinciden',
  InvalidToken: 'No se proporcionó el token de acceso o ha expirado',
  InvalidSession: 'La sesión del usuario no es válida, vuelve a iniciar sesión',
  InvalidAccess: 'Permiso denegado',
  NonOperationalError: 'Ocurrió un error en el servidor',
  UserNotExists: 'El usuario no existe',
  InvalidAction: 'Acción inválida',
  EmailNotVerified: 'Correo electrónico no verificado',
  NoWalletFoundError: 'No se encontró una billetera con los datos indicados',
  NotEnoughBalanceError: 'El saldo no es suficiente para realizar la operación',
  SomethingWentWrong: 'Algo salió mal',
  AccountNotActive: 'La cuenta no está activa',
  UserAlreadyExists: 'El usuario ya existe',
  RecordNotFound: 'Registro no encontrado',
  WalletDoesNotBelongToUser: 'La billetera no pertenece a este usuario',
  TransactionPasswordNotSet: 'Establece una contraseña de transacción de 6 dígitos en Ajustes de la cuenta antes de retirar.',
  InvalidTransactionPassword: 'La contraseña de transacción es incorrecta.'

}

const otherTranslationKeys = {
  betAmount: 'Monto de la apuesta',
  betHistory: 'Historial de apuestas',
  provablyFair: 'Provablemente justo',
  minimumBet: 'Apuesta mínima',
  maximumBet: 'Apuesta máxima',
  selectYourBetAmount: 'Selecciona el monto de tu apuesta',
  buyInAmount: 'Monto de entrada',
  selectYourBuyInAmountFromGivenRange: 'Selecciona tu monto de entrada del rango dado',
  profitOnWin: 'Ganancia al ganar',
  noOfBets: 'Número de apuestas',
  auto: 'Automático',
  half: '½',
  double: '2X',
  start: 'Iniciar',
  cancel: 'Cancelar',
  prediction: 'Predicción',
  luckyNumber: 'Número de la suerte',
  multiplier: 'Multiplicador',
  chanceToWin: 'Probabilidad de ganar',
  betBtn: 'Realizar apuesta',
  bets: 'Apuestas',
  depositBtn: 'Depositar',
  rollOver: 'Por encima',
  rollUnder: 'Por debajo',
  invalidBetAmount: 'Monto de apuesta inválido',
  maxBetAmountLimit: 'Se superó el límite máximo de apuesta de {{value}}',
  minBetAmountLimit: 'El monto mínimo de apuesta es {{value}}.',
  noBalance: 'El monto de la apuesta es mayor que el saldo de la billetera',
  noAutoCashout: 'La tasa automática es obligatoria.',
  autoRateLimitWarning: 'La tasa automática debe ser mayor que {{value}}',
  invalidWalletAddressLength: 'Longitud de la dirección de billetera de {{currency}} inválida ({{actual}} caracteres). Las direcciones de {{currency}} deben tener {{expected}} caracteres.',
  invalidWalletAddressFormat: 'Dirección de billetera de {{currency}} inválida. Por favor, revisa la dirección e inténtalo de nuevo.',
  withdrawExceedsMax: 'El monto supera el saldo máximo retirable ({{max}} {{currency}}).',
  maxWithdrawAmountLabel: 'Máximo retirable: {{max}} {{currency}}',
  transactionPassword: 'Contraseña de transacción',
  transactionPasswordSetHint: 'Establece una contraseña de 6 dígitos requerida para enviar retiros de criptomonedas.',
  transactionPasswordUpdateHint: 'Actualiza periódicamente tu contraseña de transacción de 6 dígitos para mantener seguros los retiros.',
  transactionPasswordRequired: 'La contraseña de transacción es obligatoria',
  transactionPasswordLength: 'La contraseña de transacción debe tener exactamente 6 dígitos.',
  transactionPasswordsMustMatch: 'Las contraseñas de transacción deben coincidir',
  sixDigitTransactionPassword: 'Contraseña de 6 dígitos',
  currentTransactionPassword: 'Contraseña de transacción actual',
  newTransactionPassword: 'Nueva contraseña de transacción',
  repeatNewTransactionPassword: 'Repite la nueva contraseña de transacción',
  setTransactionPassword: 'Establecer contraseña de transacción',
  updateTransactionPassword: 'Actualizar contraseña de transacción',
  transactionPasswordUpdated: 'Contraseña de transacción actualizada',
  enterTransactionPassword: 'Ingresa la contraseña de transacción',
  enterTransactionPasswordHint: 'Ingresa tu contraseña de transacción de 6 dígitos para continuar este retiro.',
  transactionPasswordNotSetTitle: 'Se requiere contraseña de transacción',
  transactionPasswordNotSetHint: 'Establece una contraseña de transacción de 6 dígitos en Ajustes de la cuenta antes de retirar criptomonedas.',
  goToAccountSettings: 'Ir a ajustes de la cuenta',
  confirmWithdrawal: 'Confirmar retiro',
  confirmWithdrawalHint: 'Confirma que deseas enviar este retiro. No se puede deshacer después de enviarlo.',
  confirmSend: 'Confirmar envío',
  withdrawalAddressLabel: 'Dirección de destino',
  withdrawalAmountLabel: 'Monto',
  withdrawBeingVerified: 'Tu retiro se está verificando. No envíes otra solicitud hasta que se confirme el estado.',
  withdrawPendingReview: 'CoinPayments rechazó el retiro antes de crear el pago. La solicitud permanece pendiente de revisión.'

}

const predictionMarketTranslations = {
  error: 'Error',
  somethingWentWrongPleaseTryAgain: 'Algo salió mal. Por favor, inténtalo de nuevo.',
  market: 'Mercado',
  limit: 'Límite',
  buy: 'Comprar',
  sell: 'Vender',
  yes: 'Sí',
  no: 'No',
  yesCents: 'Sí {{cents}}¢',
  noCents: 'No {{cents}}¢',
  up: 'Sube',
  down: 'Baja',
  upCents: 'Sube {{cents}}¢',
  downCents: 'Baja {{cents}}¢',
  outcomeShares: 'Participaciones {{outcome}}',
  avgOutcomePrice: 'Precio promedio {{outcome}}',
  splitCollateralIntoShares: 'Divide la garantía en participaciones {{yes}} y {{no}} para este mercado.',
  mergeMatchedSharesIntoCollateral: 'Combina participaciones {{yes}} y {{no}} emparejadas de vuelta en garantía.',
  notEnoughYesAndNoSharesToMerge: 'No hay suficientes participaciones {{yes}} y {{no}} para combinar.',
  equalYesAndNoShares: 'Participaciones {{yes}} y {{no}} iguales · {{marketTitle}}',
  amountYesAndNo: '{{amount}} {{yes}} + {{amount}} {{no}}',
  sharesYesAndNo: '{{shares}} {{yes}} + {{shares}} {{no}}',
  split: 'Dividir',
  merge: 'Combinar',
  amount: 'Monto',
  shares: 'Participaciones',
  cancel: 'Cancelar',
  submit: 'Enviar',
  refresh: 'Actualizar',
  loading: 'Cargando',
  loadMore: 'Cargar más',
  gotIt: 'Entendido',
  next: 'Siguiente',
  previous: 'Anterior',
  trade: 'Operar',
  portfolio: 'Portafolio',
  rules: 'Reglas',
  volume: 'Volumen',
  category: 'Categoría',
  notAvailable: 'N/D',
  open: 'Abierto',
  closed: 'Cerrado',
  removed: 'Eliminado',
  resolved: 'Resuelto',
  cancelled: 'Cancelado',
  settled: 'Liquidado',
  ask: 'Venta',
  bid: 'Compra',
  asks: 'Ventas',
  bids: 'Compras',
  total: 'Total',
  outcome: 'Resultado',
  options: 'Opciones',
  history: 'Historial',
  positions: 'Posiciones',
  orders: 'Órdenes',
  activity: 'Actividad',
  comments: 'Comentarios',
  delete: 'Eliminar',
  reply: 'Responder',
  postComment: 'Publicar comentario',
  likeCount: 'Me gusta ({{count}})',
  limitPrice: 'Precio límite',
  postOnly: 'Solo publicación',
  youPay: 'Pagas',
  shareCost: 'Costo de participaciones',
  toWin: 'Para ganar',
  youWillReceive: 'Recibirás',
  averagePrice: 'Precio promedio',
  payable: 'A pagar',
  processingFee: 'Tarifa de procesamiento',
  processingFees: 'Tarifas de procesamiento',
  estProcessingFee: 'Tarifa de procesamiento estimada',
  estProcessingFeeIncluded: 'Tarifa de procesamiento estimada (incluida)',
  processingFeeRefundable: 'Tarifa de procesamiento (reembolsable)',
  showMore: 'mostrar más...',
  feePerShareIfItFillsNow: 'Tarifa por participación si se ejecuta ahora',
  marketSettled: 'Mercado liquidado',
  resultDeclared: 'Resultado declarado',
  awaitingSettlement: 'Esperando la liquidación...',
  noMatchResult: 'Sin cruce',
  emailChangeOtpSent: 'Se envió un código de 6 dígitos para verificación a la nueva dirección de correo. Revísalo e ingrésalo.',
  noMatchOnlyOneUser: 'Sin cruce: solo un usuario operó',
  noMatchAllSameSide: 'Sin cruce: todas las órdenes fueron del mismo lado',
  noMatchBelowMinimum: 'Sin cruce: el total fue inferior a $1.00',
  goToLiveMarket: 'Ir al mercado en vivo',
  tradingClosedForThisOption: 'La operación está cerrada para esta opción.',
  goBack: 'Volver',
  yourPosition: 'Tu posición',
  availableToTrade: 'Disponible para operar',
  locked: 'Bloqueado',
  profitLoss: 'G/P',
  yesShares: 'Participaciones Sí',
  noShares: 'Participaciones No',
  avgYesPrice: 'Precio promedio Sí',
  avgNoPrice: 'Precio promedio No',
  payoutProfitLoss: 'Pago G/P',
  won: 'Ganado',
  outcomeWon: '{{outcome}} ganó',
  buyOutcome: 'Comprar {{outcome}}',
  sellOutcome: 'Vender {{outcome}}',
  decreaseAmount: 'Disminuir monto',
  increaseAmount: 'Aumentar monto',
  decreaseShares: 'Disminuir participaciones',
  increaseShares: 'Aumentar participaciones',
  decreaseLimitPrice: 'Disminuir precio límite',
  increaseLimitPrice: 'Aumentar precio límite',
  nobodySellingRightNow: 'Nadie está vendiendo ahora mismo. Prueba una orden límite para que la tuya pueda esperar.',
  nobodyBuyingRightNow: 'Nadie está comprando ahora mismo. Prueba una orden límite para que la tuya pueda esperar.',
  tooMuchMaxBuy: 'Demasiado. El máximo que puedes comprar ahora es {{amount}}$.',
  tooManySharesMaxSell: 'Demasiadas participaciones. El máximo que puedes vender ahora es {{amount}}.',
  restAsMakerOnly: 'Queda solo como creador; se rechaza si tomaría liquidez',
  // mergeMatchedSharesIntoCollateral: 'Combina participaciones Sí y No emparejadas de vuelta en garantía.',
  sharesPerSide: 'Participaciones (por lado)',
  // splitCollateralIntoShares: 'Divide la garantía en participaciones Sí y No para este mercado.',
  closeTradePanel: 'Cerrar panel de operación',
  openTradePanel: 'Abrir panel de operación',
  orderSummary: 'Resumen de la orden',
  youSell: 'Vendes',
  youMerge: 'Combinas',
  estProceedsAtMarket: 'Ingresos estimados al mercado',
  splitCollateral: 'Dividir garantía',
  mergeShares: 'Combinar participaciones',
  splitHasNoProcessingFee: 'Dividir no tiene tarifa de procesamiento.',
  mergeHasNoProcessingFee: 'Combinar no tiene tarifa de procesamiento.',
  includedInWhatYouPay: 'Incluida en lo que pagas. Se aplica cuando tu orden coincide con ofertas disponibles.',
  deductedFromWhatYouReceive: 'Se deduce de lo que recibes cuando tu orden coincide con compras disponibles.',
  heldWithYourOrder: 'Se retiene con tu orden. Se reembolsa si espera en el libro. Solo se cobra si se ejecuta de inmediato.',
  onlyIfOrderFillsRightAway: 'Solo si tu orden se ejecuta de inmediato: se descuenta de los ingresos. No hay tarifa si espera en el libro.',
  makerFeeRebateExplanation: 'Si otra persona toma tu orden en espera, puedes ganar {{rebatePercent}}% de su tarifa.',
  postOnlyOrderExplanation: 'Solo publicación: esta orden solo espera. Si se ejecutara de inmediato, se cancela y recibes tu dinero de vuelta.',
  notEnoughMoneyInWallet: 'No hay suficiente dinero en tu billetera.',
  // notEnoughYesAndNoSharesToMerge: 'No hay suficientes participaciones Sí y No para combinar.',
  notEnoughSharesToSell: 'No tienes tantas participaciones para vender.',
  orderCrossesOwnSellOrder: 'La orden cruzaría tu propia orden de venta en este resultado. Cancela o baja primero esa venta.',
  orderCrossesOwnOppositeBuy: 'La orden cruzaría tu propia compra del lado opuesto (Sí+No >= 100¢). Cancela o ajusta primero esa orden.',
  orderCrossesOwnBuyOrder: 'La orden cruzaría tu propia orden de compra en este resultado. Cancela o sube primero esa compra.',
  placedBuyLimitOrder: 'Se colocó una orden límite de compra de {{shares}} participaciones a precio {{price}}',
  placedSellLimitOrder: 'Se colocó una orden límite de venta de {{shares}} participaciones a precio {{price}}',
  placedBuyMarketOrder: 'Se colocó una orden de mercado de compra por monto {{amount}}',
  placedSellMarketOrder: 'Se colocó una orden de mercado de venta de {{shares}} participaciones',
  mergedYesAndNoShares: 'Se combinaron {{quantity}} participaciones sí y no en un monto de {{amount}}',
  splitAmountIntoYesAndNoShares: 'Se dividió el monto {{amount}} en {{yesShares}} participaciones sí y {{noShares}} participaciones no',
  closedBuyLimitOrder: 'Se cerró una orden límite de compra de {{remainingShares}} participaciones a precio {{price}}, total {{shares}}',
  closedSellLimitOrder: 'Se cerró una orden límite de venta de {{remainingShares}} participaciones a precio {{price}}, total {{shares}}',
  closedBuyMarketOrder: 'Se cerró una orden de mercado de compra por monto {{remainingAmount}}, total {{amount}}',
  closedSellMarketOrder: 'Se cerró una orden de mercado de venta de {{remainingShares}} participaciones, total {{shares}}',
  boughtSharesFromSeller: 'Compró {{quantity}} participaciones a precio {{price}} de {{sellerName}}',
  soldSharesToBuyer: 'Vendió {{quantity}} participaciones a precio {{price}} a {{buyerName}}',
  marketResolvedWithOutcome: 'El mercado se resolvió con resultado {{outcome}}. Pago: ${{payout}} ({{winningShares}} participaciones ganadoras).',
  buyerReceivedSharesSystemMinted: '{{buyerName}} recibió {{quantity}} participaciones a {{price}} (acuñadas por el sistema)',
  buyerBoughtSharesFromSeller: '{{buyerName}} compró {{quantity}} participaciones a {{price}} de {{sellerName}}',
  sellerSoldSharesToSystem: '{{sellerName}} vendió {{quantity}} participaciones a {{price}} al SISTEMA',
  sellerSoldSharesToBuyer: '{{sellerName}} vendió {{quantity}} participaciones a {{price}} a {{buyerName}}',
  notifications: 'Notificaciones',
  unreadNotifications: '{{count}} notificaciones sin leer',
  recentCount: '{{count}} recientes',
  loadingNotifications: 'Cargando notificaciones...',
  noNotificationsYet: 'Todavía no hay notificaciones. Recibirás avisos cuando las órdenes se emparejen, se completen o los mercados se resuelvan.',
  activityUpdate: 'Actualización de actividad',
  marketResolved: 'Mercado resuelto',
  walletUpdated: 'Billetera actualizada',
  justNow: 'Justo ahora',
  pickAMarket: 'Elige un mercado',
  pickAMarketDescription: 'Abre cualquier mercado y elige Sí o No según tu predicción. Luego usa el panel de órdenes para obtener participaciones.',
  preferLimitOrders: 'Prefiere órdenes límite',
  preferLimitOrdersDescription: 'Empieza aquí. Define el precio exacto (¢) y la cantidad de participaciones que quieres. Tu orden permanece en el libro hasta que alguien la iguala, así controlas el precio.',
  noFillUseSplit: '¿Sin ejecución? Usa Dividir',
  noFillUseSplitDescription: 'Si no hay suficiente liquidez para ejecutar una orden límite, divide tu garantía en participaciones iguales de Sí y No. Luego puedes vender el lado que no quieras.',
  needSpeedMarketOrders: '¿Necesitas rapidez? Órdenes de mercado',
  needSpeedMarketOrdersDescription: 'Las órdenes de mercado se ejecutan al instante contra el libro actual. Úsalas cuando quieras participaciones ahora y aceptes pagar el precio del mercado en vivo.',
  holdOrCashOut: 'Mantén o cobra',
  holdOrCashOutDescription: 'Vende en cualquier momento antes de la resolución o mantén hasta que el mercado liquide. Las participaciones ganadoras pagan $1 cada una; las perdedoras se liquidan a $0.',
  restsOnTheBookUntilMatched: 'Permanece en el libro hasta ser emparejada',
  convertCashIntoYesAndNoShares: 'Convierte efectivo en participaciones Sí + No',
  estShares: 'Participaciones est.',
  fillsInstantlyAtBookPrices: 'Se ejecuta al instante a precios del libro',
  resolvedYes: 'Resuelto · Sí',
  payoutCredited: 'Pago acreditado',
  closeHowItWorks: 'Cerrar cómo funciona',
  tryItOut: '¿Probarlo?',
  demoGuide: 'Guía',
  demoGuideReopen: 'Reabrir la guía demo',
  demoGuideSkip: 'Saltar guía',
  demoGuideFinish: 'Finalizar',
  demoGuideStepOf: 'Paso {{current}} de {{total}}',
  demoGuideBack: 'Atrás',
  demoGuideWelcomeTitle: 'Bienvenido al playground',
  demoGuideWelcomeBody: 'Este es un mercado demo seguro con dinero de práctica. Te señalaré cada parte de la interfaz y te explicaré qué hace: prueba la acción si quieres, o toca Siguiente en cualquier momento.',
  demoGuideWelcomeHint: 'Empiezas con $1000 de saldo demo. Nada de esto es real.',
  demoGuideLimitTitle: 'Prefiere las órdenes límite',
  demoGuideLimitBody: 'Una orden límite te permite fijar el precio exacto (¢) y el número de participaciones. Permanece en el libro hasta que alguien la empareje, así controlas el precio en lugar de aceptar el que esté activo.',
  demoGuideLimitHint: 'Abrí Límite y sugerí Comprar Sí a 45¢ × 10. Envía si quieres probarlo, o Siguiente para seguir leyendo.',
  demoGuideOrderbookTitle: 'Tu orden en el libro',
  demoGuideOrderbookBody: 'El libro de órdenes muestra bids y asks en espera. Cuando colocas una orden límite, aparece aquí (a menudo marcada como Tú) hasta que se ejecute o la canceles.',
  demoGuideOrderbookHint: 'Si aún no tienes una orden en espera, coloco un bid demo pequeño para que veas cómo se ve.',
  demoGuidePostOnlyTitle: 'Solo publicación (solo maker)',
  demoGuidePostOnlyBody: 'Solo publicación significa que tu compra límite solo descansa como maker. Si el precio se ejecutara de inmediato contra un ask, la orden se rechaza y tu dinero vuelve: útil cuando nunca quieres tomar liquidez.',
  demoGuidePostOnlyHint: 'Solo publicación está marcada con un bid de 45¢ que no cruza el libro. Prueba enviar, o Siguiente para continuar.',
  demoGuideCancelTitle: 'Cancelar una orden en espera',
  demoGuideCancelBody: '¿Cambiaste de opinión? Las órdenes abiertas están en Mi posición. Cancelar libera el efectivo reservado en compras (o las participaciones bloqueadas en ventas) para que puedas reutilizarlos.',
  demoGuideCancelHint: 'Usa Cancelar en una fila aquí si quieres practicar: mantengo un bid en espera disponible para ti.',
  demoGuideMarketTitle: '¿Necesitas velocidad? Órdenes de mercado',
  demoGuideMarketBody: 'Las órdenes de mercado se ejecutan al instante contra el libro actual. Úsalas cuando quieras participaciones ya y te esté bien pagar los precios ask vivos en lugar de esperar tu propio límite.',
  demoGuideMarketHint: 'Configuré una compra de $5 en Mercado. Envía para ver una ejecución instantánea, o Siguiente para seguir.',
  demoGuideMintTitle: '¿Sin asks? El mint sigue funcionando',
  demoGuideMintBody: 'Si nadie está vendiendo, aún puedes obtener participaciones. El motor puede acuñar Sí+No desde la garantía emparejando tu compra con un bid del lado opuesto, así que un ask vacío no siempre significa “bloqueado”.',
  demoGuideMintHint: 'Vacío los asks de esta opción. Una compra de mercado de $5 está lista: observa cómo aparecen participaciones aunque el lado ask esté vacío.',
  demoGuideSplitTitle: '¿Sin ejecución? Usa Dividir',
  demoGuideSplitBody: 'Dividir convierte la garantía en participaciones Sí y No iguales al instante, sin contraparte. Útil cuando el libro es fino y quieres inventario para vender después el lado que no quieras.',
  demoGuideSplitHint: 'Sugerí dividir $10. Pruébalo para ver subir Sí y No, o Siguiente para continuar.',
  demoGuideMergeTitle: 'Fusionar de vuelta a efectivo',
  demoGuideMergeBody: 'Fusionar es lo contrario de Dividir: quema participaciones Sí y No iguales para recuperar garantía. Útil cuando tienes ambos lados y quieres aplanar a efectivo.',
  demoGuideMergeHint: 'Sugerí fusionar 5 por lado. Necesitas Sí y No disponibles que coincidan: Dividir primero si hace falta.',
  demoGuideResolveTitle: 'Cerrar y liquidar',
  demoGuideResolveBody: 'Cuando termina la operación, el mercado se cierra y luego se liquida. Las participaciones ganadoras pagan $1 cada una; las perdedoras se liquidan a $0. En demo, Gestionar mercado te permite simular cerrar → elegir un ganador → liquidar.',
  demoGuideResolveHint: 'Abre el panel si no está abierto. Cierra primero, luego elige Sí/No y Liquida para la opción seleccionada.',
  demoGuideDoneTitle: 'Ya tienes lo básico',
  demoGuideDoneBody: 'Límite para controlar el precio, solo publicación para quedarte solo como maker, cancelar para liberar fondos reservados, mercado para velocidad, mint cuando no hay asks, dividir/fusionar para inventario, y gestionar mercado para la resolución.',
  demoGuideDoneHint: 'Puedes repetirla cuando quieras desde el botón Guía. El dinero demo se reinicia al volver a entrar en el modo demo.',
  demoGuideWaitingForAction: 'Completa la acción resaltada para continuar.',
  demoGuideDoThisFirst: 'Haz esto primero',
  willThereBeAUsRecessionThisYear: '¿Habrá una recesión en EE. UU. este año?',
  exitTutorialAndReturnToMarkets: 'Salir del tutorial y volver a los mercados',
  exitDemo: 'Salir de la demo',
  howItWorks: 'Cómo funciona',
  ganamosPolyTrade: 'Ganamos PolyTrade',
  trending: 'Tendencias',
  new: 'Nuevo',
  buyYes: 'Comprar Sí',
  breaking: 'Última hora',
  noBreakingMarketsRightNow: 'No hay mercados de última hora en este momento.',
  backToMarkets: 'Volver a los mercados',
  markets: 'Mercados',
  openFullMarket: 'Abrir mercado completo',
  tradeMarket: 'Operar mercado',
  previousMarket: 'Mercado anterior',
  nextMarket: 'Siguiente mercado',
  breakingMarkets: 'Mercados de última hora',
  showBreakingMarket: 'Mostrar mercado de última hora {{index}}',
  featuredMarkets: 'Mercados destacados',
  topMovers: 'Mayores movimientos',
  viewAll: 'Ver todo',
  liveTrades: 'Operaciones en vivo',
  live: 'En vivo',
  featuredMarket: 'Mercado destacado',
  untitledMarket: 'Mercado sin título',
  traders: 'Operadores',
  endsIn: 'Termina en',
  tradeNow: 'Operar ahora',
  showFeaturedMarket: 'Mostrar mercado destacado {{index}}',
  openNewsHeadline: 'Abrir noticias: {{headline}}',
  openNewsStatus: 'Abrir noticias: {{statusText}}',
  news: 'Noticias',
  minimizeNews: 'Minimizar noticias',
  expandNews: 'Expandir noticias',
  closeNews: 'Cerrar noticias',
  liveWire: 'Cable en vivo',
  categoryNews: 'Noticias de {{category}}',
  categoryDesk: 'Mesa de {{category}}',
  topHeadlinesAndRelatedCoverage: 'Titulares principales y cobertura relacionada para esta categoría de mercado',
  topHeadlinesCount: 'Top {{count}} titulares',
  moreRelevantNews: 'Más noticias relevantes',
  noNewsStoriesForThisCategoryYet: 'Todavía no hay noticias para esta categoría.',
  pullingHeadlinesFromTheWire: 'Obteniendo titulares del cable…',
  scanningWire: 'Escaneando el cable…',
  categoryWaitingForStories: '{{category}} · esperando noticias',
  categoryStoriesCount: '{{category}} · {{count}} noticias',
  searchMarkets: 'Buscar mercados...',
  searchPortfolioActivity: 'Buscar actividad del portafolio',
  refreshPortfolioActivity: 'Actualizar actividad del portafolio',
  portfolioSections: 'Secciones del portafolio',
  noPositionsFound: 'No se encontraron posiciones',
  yourOwnedPositionsWillAppearHere: 'Tus posiciones aparecerán aquí.',
  noOrdersFound: 'No se encontraron órdenes',
  marketOrdersWillAppearInThisSection: 'Las órdenes de mercado aparecerán en esta sección.',
  limitOrdersWillAppearInThisSection: 'Las órdenes límite aparecerán en esta sección.',
  noActivityYet: 'Aún no hay actividad',
  completedTradesAndSettlementsWillBeListedHere: 'Las operaciones completadas y liquidaciones se listarán aquí.',
  cancelThisOrder: '¿Cancelar esta orden?',
  cancelThisOrderDescription: 'Esto eliminará tu orden límite abierta del libro. Puedes colocar una nueva en cualquier momento.',
  keepOrder: 'Mantener orden',
  cancelOrder: 'Cancelar orden',
  yourTradingDesk: 'Tu mesa de operación',
  stateFilters: 'Filtros de estado',
  tablePagination: 'Paginación de tabla',
  pagination: 'Paginación',
  previousPage: 'Página anterior',
  nextPage: 'Página siguiente',
  noDataAvailable: 'No hay datos disponibles',
  dataWillAppearHere: 'Los datos aparecerán aquí',
  thumbnail: 'Miniatura',
  actions: 'Acciones',
  rowThumbnail: 'Miniatura de fila',
  yourPerformance: 'Tu rendimiento',
  walletBalance: 'Saldo de la billetera',
  totalProfitIncludingTakerFee: 'Ganancia total incluyendo tarifa de tomador',
  totalProfit: 'Ganancia total',
  hideTakerFee: 'Ocultar tarifa de tomador',
  showTakerFee: 'Mostrar tarifa de tomador',
  profitOverTime: 'Ganancia a lo largo del tiempo',
  noChartDataAvailable: 'No hay datos de gráfico disponibles',
  profitHistoryWillAppearAsTradesArePlaced: 'El historial de ganancias aparecerá a medida que se coloquen operaciones.',
  profitChartTimeRange: 'Rango de tiempo del gráfico de ganancias',
  userActivity: 'Actividad del usuario',
  userActivityTitle: 'Actividad del usuario',
  userActivityTabs: 'Pestañas de actividad del usuario',
  refreshUserActivity: 'Actualizar actividad del usuario',
  addYourComment: 'Añade tu comentario',
  shareYourThoughtsAboutThisMarket: 'Comparte tu opinión sobre este mercado...',
  anonymous: 'anónimo',
  hideReplies: 'Ocultar respuestas',
  showReplies: 'Mostrar respuestas',
  writeAReply: 'Escribe una respuesta...',
  loadingEllipsis: 'Cargando...',
  recentMarketBuysAndSellsWillAppearHere: 'Las compras y ventas recientes del mercado aparecerán aquí.',
  topHolders: 'Mayores tenedores',
  topPositions: 'Mejores posiciones',
  noTopPositionsFound: 'No se encontraron mejores posiciones',
  topPositionsWillAppearHereWithHighestRealizedPnl: 'Las mejores posiciones aparecerán aquí con la mayor ganancia/pérdida realizada',
  yesHolders: 'Tenedores de Sí',
  noHolders: 'Tenedores de No',
  noTopHoldersFoundForYesOutcome: 'No se encontraron mayores tenedores para el resultado Sí',
  topHoldersWillAppearHereForYesOutcome: 'Los mayores tenedores aparecerán aquí para el resultado Sí',
  noTopHoldersFoundForNoOutcome: 'No se encontraron mayores tenedores para el resultado No',
  topHoldersWillAppearHereForNoOutcome: 'Los mayores tenedores aparecerán aquí para el resultado No',
  optionDetailsTabs: 'Pestañas de detalles de opción',
  orderbookOutcome: 'Resultado del libro de órdenes',
  orderbook: 'Libro de órdenes',
  graph: 'Gráfico',
  myPosition: 'Mi posición',
  yesBook: 'Libro Sí',
  noBook: 'Libro No',
  spread: 'Diferencial',
  you: 'Tú',
  noAsks: 'Sin ventas',
  noBids: 'Sin compras',
  loadingPosition: 'Cargando posición...',
  yourOrders: 'Tus órdenes',
  marketOrdersForThisOptionWillAppearHere: 'Las órdenes de mercado para esta opción aparecerán aquí.',
  limitOrdersForThisOptionWillAppearHere: 'Las órdenes límite para esta opción aparecerán aquí.',
  rulesAndMarketContext: 'Reglas y contexto del mercado',
  marketResolvesBasedOnListedCriteriaAndFinalOutcomeData: 'El mercado se resuelve según los criterios indicados y los datos finales del resultado.',
  matchingEngineSettlesOpenOrdersUsingMarketResolutionRules: 'El motor de emparejamiento liquida órdenes abiertas usando las reglas de resolución del mercado.',
  ambiguousOutcomesAreHandledByPlatformAdjudicationPolicy: 'Los resultados ambiguos se manejan según la política de adjudicación de la plataforma.',
  defaultPredictionMarketRules: `
  Reglas:
  - Este mercado se resuelve según el resultado descrito en la pregunta. La resolución utilizará fuentes públicas y confiables como declaraciones oficiales, proveedores de datos verificados u organizaciones de noticias reputadas.
  - Si el resultado queda claro antes de la fecha final indicada, el mercado puede resolverse anticipadamente. Si el evento no puede determinarse o la pregunta se vuelve ambigua, la plataforma puede resolver el mercado según su mejor criterio con base en la información disponible.
  - Todas las resoluciones son finales.`,
  pleaseLogInToFavouriteQuestions: 'Inicia sesión para marcar preguntas como favoritas.',
  removeFromFavourites: 'Quitar de favoritos',
  addToFavourites: 'Agregar a favoritos',
  unableToUpdateFavouriteQuestionPleaseTryAgain: 'No se pudo actualizar la pregunta favorita. Por favor, inténtalo de nuevo.',
  marketOrderInProgress: 'Orden de mercado en curso',
  noActiveMarketOrder: 'No hay orden de mercado activa',
  marketOrderRunning: 'Orden de mercado en ejecución',
  remainingAmount: 'Restante: ${{amount}}',
  remainingShares: 'Restante: {{shares}} participaciones',
  statusState: 'Estado: {{state}}',
  noMarketOrderRunning: 'No hay ninguna orden de mercado en ejecución. Puedes encontrar órdenes de mercado anteriores en la pestaña Órdenes de tu página de Portafolio.',
  deposit: 'Depositar',
  withdraw: 'Retirar',
  closeWalletActivityModal: 'Cerrar modal de actividad de la billetera',
  enterAmountToAction: 'Ingresa el monto a {{action}}',
  depositSuccessful: 'Depósito exitoso',
  depositFailedPleaseTryAgain: 'El depósito falló. Por favor, inténtalo de nuevo.',
  withdrawalSuccessful: 'Retiro exitoso',
  withdrawFailedPleaseTryAgain: 'El retiro falló. Por favor, inténtalo de nuevo.',
  mergeSuccessfulBalanceCredited: 'Combinación exitosa. Saldo acreditado.',
  mergeSuccessfulCreditPending: 'Combinación exitosa. Crédito pendiente: el saldo se actualizará en breve.',
  orderPlacedSuccessfully: 'Orden realizada con éxito',
  placeOrderFailedPleaseTryAgain: 'No se pudo realizar la orden. Por favor, inténtalo de nuevo.',
  orderCancelledSuccessfully: 'Orden cancelada con éxito',
  cancelLimitOrderFailedPleaseTryAgain: 'No se pudo cancelar la orden límite. Por favor, inténtalo de nuevo.',
  commentAdded: 'Comentario agregado',
  addCommentFailedPleaseTryAgain: 'No se pudo agregar el comentario. Por favor, inténtalo de nuevo.',
  commentDeleted: 'Comentario eliminado',
  deleteCommentFailedPleaseTryAgain: 'No se pudo eliminar el comentario. Por favor, inténtalo de nuevo.',
  failedToLoadNotifications: 'No se pudieron cargar las notificaciones',
  commentCannotBeEmpty: 'El comentario no puede estar vacío.',
  commentNotFound: 'Comentario no encontrado.',
  demoMultiOutcomeMarket: 'Mercado demo de múltiples resultados',
  outcomeAlpha: 'Resultado Alfa',
  outcomeBeta: 'Resultado Beta',
  outcomeGamma: 'Resultado Gamma',
  greatMarketToLearnLimitOrders: 'Excelente mercado para aprender órdenes límite: intenta colocar una compra por debajo del precio actual.',
  theOrderbookUpdatesLiveOnceYouStartPlacingDemoOrders: 'El libro de órdenes se actualiza en vivo una vez que empiezas a colocar órdenes demo.',
  demoOutcome: 'Resultado demo',
  demoMarketControls: 'Controles del mercado demo',
  simulateCloseAndSettlementToSeeHowTheMarketBehaves: 'Simula el cierre y la liquidación para ver cómo se comporta el mercado.',
  closePanel: 'Cerrar panel',
  closeMarket: 'Cerrar mercado',
  tradingOpen: 'Operación abierta',
  stopsTradingClearsTheOrderbookAndClosesOpenOrders: 'Detiene la operación, limpia el libro de órdenes y cierra las órdenes abiertas. Los montos prepagados restantes de las órdenes de compra vuelven a tu billetera. Las posiciones permanecen abiertas hasta la liquidación.',
  marketClosed: 'Mercado cerrado',
  settleMarket: 'Liquidar mercado',
  ready: 'Listo',
  awaitingClose: 'Esperando cierre',
  pickTheWinningOutcomeDescription: 'Elige el resultado ganador. Las participaciones ganadoras pagan $1 cada una, las posiciones se limpian y las opciones se muestran como liquidadas con el resultado final.',
  winningOutcome: 'Resultado ganador',
  settlementOutcome: 'Resultado de liquidación',
  closeManageMarketPanel: 'Cerrar panel de gestión del mercado',
  manageMarket: 'Gestionar mercado',
  manageDemoMarket: 'Gestionar mercado demo',
  noChartDataYet: 'Aún no hay datos del gráfico',
  priceHistoryWillAppearHereAsTradesHappen: 'El historial de precios aparecerá aquí a medida que ocurran operaciones.',
  chartTimeRange: 'Rango de tiempo del gráfico',
  allMarkets: 'Todos los mercados',
  backToCollateral: 'Volver a garantía · {{marketTitle}}',
  demo: 'Demo',
  depositing: 'Depositando...',
  // equalYesAndNoShares: 'Participaciones Sí y No iguales · {{marketTitle}}',
  estValue: 'Est. {{value}}',
  favouriteQuestions: 'Preguntas favoritas',
  favourites: 'Favoritos',
  feePerShareFormula: 'Tarifa por participación (¢) = precio × (100 − precio) × {{coefficient}} / 10,000',
  limitBuy: 'Compra límite',
  limitSell: 'Venta límite',
  marketBuyOn: 'Compra al mercado en {{marketTitle}}',
  marketSellOn: 'Venta al mercado en {{marketTitle}}',
  marketResolutionPayoutReceived: 'Pago por resolución del mercado recibido. Nuevo saldo: {{currency}} {{formattedBalance}}',
  marketsPagination: 'Paginación de mercados',
  noFavouriteQuestionsYet: 'Aún no hay preguntas favoritas.',
  noTitle: 'Sin título',
  optionNumber: 'Opción {{number}}',
  postOnlyLimitBuy: 'Compra límite solo publicación',
  system: 'SISTEMA',
  unknownOrderType: 'Tipo de orden desconocido: {{orderType}}',
  withdrawing: 'Retirando...',
  yourBalanceWasCredited: 'Tu saldo fue acreditado. Nuevo saldo: {{currency}} {{formattedBalance}}',
  yourBalanceWasDebited: 'Tu saldo fue debitado. Nuevo saldo: {{currency}} {{formattedBalance}}',
  thisMarket: 'este mercado',
  yourPositionText: 'tu posición',
  // amountYesAndNo: '{{amount}} Sí + {{amount}} No',
  daysAgo: 'hace {{days}} d',
  hoursAgo: 'hace {{hours}} h',
  minutesAgo: 'hace {{minutes}} min',
  outcomeSharesAtMarket: 'Participaciones {{outcome}} al mercado',
  // sharesYesAndNo: '{{shares}} Sí + {{shares}} No',
  sharesOutcomeAtPrice: '{{shares}} {{outcome}} @ {{price}}¢ · {{marketTitle}}',
  sharesOutcome: '{{shares}} participaciones {{outcome}}',
  marketQuestionResolved: 'El mercado "{{questionTitle}}" ha sido resuelto.',
  cryptoRelativeToday: 'hoy',
  cryptoRelativeTomorrow: 'mañana',
  cryptoRelativeYesterday: 'ayer',
  cryptoPriceAtTime: '{{asset}} precio a las {{time}}',
  cryptoUpOrDownAtTime: '{{asset}} Sube o Baja {{day}} a las {{time}}',
  cryptoUpOrDownDay: '{{asset}} Sube o Baja {{day}}',
  cryptoUpOrDown15min: '{{asset}} Sube o Baja 15 min',
  cryptoMoreThanPrice: 'Más de ${{price}}',
  cryptoLessThanPrice: 'Menos de ${{price}}'

}

export default {
  ...en,
  ...reservedTranslationsWithUniqueKeyNames,
  ...apiSuccessMessagesTranslations,
  ...apiErrorMessagesTranslations,
  ...otherTranslationKeys,
  ...predictionMarketTranslations
}
